import React, {Component, useState} from "react";
import {Modal, ModalHeader, ModalBody, ModalFooter, Row, Col, Form} from "reactstrap";
import {useSelector, useDispatch} from "react-redux";
import {createAction} from "../../utils/reduxUtil";
import {
    CLOSE_RESERVATION_MODAL,
    OPEN_RESERVATION_MODAL,
    OPEN_RESERVATION_SUMMARY,
    RESERVATION_MODAL_FETCH_TERMS_REQUEST,
    RESERVATION_MODAL_FETCH_TERMS_SUCCESS,
    RESERVATION_MODAL_SELECT_PRICE_LIST,
    SELECT_DAY,
    SELECT_TERM
} from "../../constants/actiontypes/reservation";
import {makeReservation, selectMonth} from "../../actions/reservation";
import Slider from "react-slick";
import {addLeadingZeros} from "../../utils/stringUtil";
import {DAY_SHORTCUTS, MONTH_NAMES} from "../../constants/dateContants";
import moment from 'moment';
import {dateFormat} from "../../utils/dateUtil";
import {getPriceText} from "../../utils/appUtil";
import {injectIntl, useIntl} from "react-intl";
import Button from '../../core/buttons/Button'
import calendarImage from '../../assets/img/calendar.svg'
import {useNavigate} from "react-router-dom";
import ModalForm from "../../core/modal/ModalForm";
import {trans} from "../../core/utils/translationUtil";
import backImage from "../../assets/img/arrow-left.svg";
import reservationConfirmationImage from '../../assets/img/reservation_confirmation.svg'
import Loader from "../Loader";
import FacilityImage from '../facility/FacilityImage'
import SelectInput from "../../core/form/select/SelectInput";
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import {createReservation, getTerms, createPrzelewy24Payment, createReservationCycle} from "../../api/app";
import Dialog from "@mui/material/Dialog";
import {MdClose} from 'react-icons/md'
import Przelewy24 from './Przelewy24'
import {
    RENTAL_MODAL_CLOSE,
    RENTAL_MODAL_SET_CYCLE,
    RENTAL_MODAL_SET_PAYMENT_METHOD,
    RENTAL_MODAL_CASH,
    RENTAL_MODAL_PRZELEWY24,
    RENTAL_MODAL_STEP_PAYMENT,
    RENTAL_MODAL_SET_STEP,
    RENTAL_MODAL_STEP_SUMMARY,
    RENTAL_MODAL_CREATE_RESERVATION, RENTAL_MODAL_STEP_SUCCESS
}
    from "../../reducers/rentalModal";
import {RENTAL_CALENDAR_LOAD_TERMS} from "../../reducers/rentalcalendar";
import handleError from "../../utils/errorUtil";

let PaymentForm = () => {


    let {business_id: businessId} = useSelector(state => state.app)

    let dispatch = useDispatch()

    let navigate = useNavigate()

    let intl = useIntl()

    let {
        isCycle,
        opened: isOpen,
        paymentMethod,
        submitting,
        przelewy24MethodId,
        facilityId,
        facilityPartId,
        cycle: {
            terms
        },
    } = useSelector(state => state.rentalModal)

    let closeModal = () => dispatch(createAction(RENTAL_MODAL_CLOSE))

    let {
        price, serviceId, date, time_from: timeFrom, time_to: timeTo, cycle: {
            daysOfWeek,
            type: cycleType,
            endsOn,
            recurrenceCount
        }
    } = useSelector(state => state.rentalModal)

    let service = useSelector(state => state.service.byId[state.rentalModal.serviceId])

    let submit = () => {
        dispatch(createAction(RENTAL_MODAL_CREATE_RESERVATION))
        if (isCycle) {
            createReservationCycle({
                service_id: serviceId,
                price: price,
                facility_id: facilityId,
                days_of_week: daysOfWeek,
                starts_on: date,
                ends_on: endsOn,
                type: cycleType,
                time_from: timeFrom,
                time_to: timeTo,
                recurrence_count: recurrenceCount,
                interval_weeks: 1,
                lighting: false,
                terms: Object.keys(terms).filter(d => terms[d].slot !== null).map(date => {
                    let slot = terms[date].slot
                    return {
                        date: slot.date,
                        time_from: slot.time_from,
                        time_to: slot.time_to,
                        price: slot.price,
                        lighting_price: null
                    }
                }),
                facility_part_id: facilityPartId ? facilityPartId : null,
                include: ['facilityParts']
            }).then((response) => {
                let reservation = response.data
                if (paymentMethod === RENTAL_MODAL_CASH) {
                    dispatch(createAction(RENTAL_MODAL_SET_STEP, RENTAL_MODAL_STEP_SUCCESS))
                    dispatch(createAction(RENTAL_CALENDAR_LOAD_TERMS))
                }
                if (paymentMethod === RENTAL_MODAL_PRZELEWY24) {
                    createPrzelewy24Payment({
                        paymentMethodId: przelewy24MethodId,
                        returnUrl: window.location.href + '?success=true',
                        reservationId: reservation.id
                    }).then(
                        response => {
                            window.location.href = response.data.url
                        }
                    )
                }
            }).catch(e => {
                handleError(e)
            })
        } else {
            createReservation({
                facility_id: facilityId,
                service_id: serviceId,
                date: date,
                time_from: timeFrom,
                time_to: timeTo,
                price: price,
                payment_method: paymentMethod,
                facility_part_id: facilityPartId,
                global_app: !businessId,
                include: ['facilityParts']
            }).then((response) => {
                let reservation = response.data
                if (paymentMethod === RENTAL_MODAL_CASH) {
                    dispatch(createAction(RENTAL_MODAL_SET_STEP, RENTAL_MODAL_STEP_SUCCESS))
                    dispatch(createAction(RENTAL_CALENDAR_LOAD_TERMS))
                }
                if (paymentMethod === RENTAL_MODAL_PRZELEWY24) {
                    createPrzelewy24Payment({
                        paymentMethodId: przelewy24MethodId,
                        returnUrl: window.location.href + '?success=true',
                        reservationId: reservation.id
                    }).then(
                        response => {
                            window.location.href = response.data.url
                        }
                    )
                }
            }).catch(e => {
                handleError(e)
            })
        }
    }

    return <>
        <div className='dialog-body'>
            <div className='rentalinfo'>
                <div>
                    <div className='service'>{service.name}</div>
                    <div className='time'>{moment(date).format('DD.MM.Y')} {timeFrom}-{timeTo}</div>
                    {service.type === 'partial-rental' && <div>
                        Część: {facilityPartId ? facilityPart[0].name : 'dowolna'}
                    </div>}
                </div>
                <div>
                    <div className='price'>{price} zł</div>
                </div>
            </div>
            <div className='rentaltype'>
                <div className={paymentMethod === RENTAL_MODAL_CASH ? 'active' : ''}
                     onClick={() => dispatch(createAction(RENTAL_MODAL_SET_PAYMENT_METHOD, RENTAL_MODAL_CASH))}>
                    <div className='icon'>
                        <svg width="38" height="33" viewBox="0 0 38 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="1.97656" y="1.76855" width="33.353" height="28.1681" fill="white"/>
                            <path
                                d="M0.576172 27.612C0.576172 28.854 1.05951 30.0451 1.91986 30.9233C2.78021 31.8015 3.9471 32.2949 5.16382 32.2949H32.6897C33.9064 32.2949 35.0733 31.8015 35.9337 30.9233C36.794 30.0451 37.2774 28.854 37.2774 27.612V4.97785C37.2774 3.73586 36.794 2.54474 35.9337 1.66652C35.0733 0.7883 33.9064 0.294922 32.6897 0.294922H5.16382C3.9471 0.294922 2.78021 0.7883 1.91986 1.66652C1.05951 2.54474 0.576172 3.73586 0.576172 4.97785L0.576172 27.612ZM22.7498 4.19736C22.7427 4.4746 22.6612 4.74455 22.5143 4.97785C22.3867 5.2141 22.1994 5.4111 21.9719 5.5483C21.7443 5.68549 21.4849 5.75786 21.2206 5.75786C20.9563 5.75786 20.6969 5.68549 20.4693 5.5483C20.2418 5.4111 20.0544 5.2141 19.9269 4.97785C19.78 4.74455 19.6985 4.4746 19.6914 4.19736C19.6983 3.92008 19.7797 3.65007 19.9269 3.41687C20.0544 3.18062 20.2418 2.98362 20.4693 2.84643C20.6969 2.70923 20.9563 2.63686 21.2206 2.63686C21.4849 2.63686 21.7443 2.70923 21.9719 2.84643C22.1994 2.98362 22.3867 3.18062 22.5143 3.41687C22.6614 3.65007 22.7429 3.92008 22.7498 4.19736ZM28.1021 4.19736C28.0949 4.4746 28.0135 4.74455 27.8666 4.97785C27.739 5.2141 27.5517 5.4111 27.3241 5.5483C27.0966 5.68549 26.8371 5.75786 26.5728 5.75786C26.3086 5.75786 26.0491 5.68549 25.8216 5.5483C25.594 5.4111 25.4067 5.2141 25.2791 4.97785C25.1322 4.74455 25.0508 4.4746 25.0436 4.19736C25.0505 3.92008 25.132 3.65007 25.2791 3.41687C25.4067 3.18062 25.594 2.98362 25.8216 2.84643C26.0491 2.70923 26.3086 2.63686 26.5728 2.63686C26.8371 2.63686 27.0966 2.70923 27.3241 2.84643C27.5517 2.98362 27.739 3.18062 27.8666 3.41687C28.0137 3.65007 28.0951 3.92008 28.1021 4.19736ZM33.4543 4.19736C33.4472 4.4746 33.3657 4.74455 33.2188 4.97785C33.0912 5.2141 32.9039 5.4111 32.6764 5.5483C32.4488 5.68549 32.1894 5.75786 31.9251 5.75786C31.6608 5.75786 31.4014 5.68549 31.1738 5.5483C30.9463 5.4111 30.759 5.2141 30.6314 4.97785C30.4845 4.74455 30.403 4.4746 30.3959 4.19736C30.4028 3.92008 30.4843 3.65007 30.6314 3.41687C30.761 3.18235 30.9487 2.98676 31.1758 2.84976C31.4029 2.71277 31.6613 2.63917 31.9251 2.63638C32.2189 2.63775 32.5061 2.72548 32.7524 2.88908C32.9986 3.05269 33.1935 3.28524 33.3136 3.55892C33.4048 3.759 33.4527 3.97672 33.4543 4.19736ZM3.6346 8.48848C3.6346 8.38498 3.67488 8.28572 3.74658 8.21254C3.81827 8.13935 3.91551 8.09824 4.01691 8.09824H33.8366C33.938 8.09824 34.0353 8.13935 34.1069 8.21254C34.1786 8.28572 34.2189 8.38498 34.2189 8.48848V27.6104C34.2189 28.0244 34.0578 28.4215 33.771 28.7142C33.4842 29.007 33.0953 29.1714 32.6897 29.1714H5.16382C4.75825 29.1714 4.36928 29.007 4.0825 28.7142C3.79572 28.4215 3.6346 28.0244 3.6346 27.6104V8.48848Z"
                                fill="#4A3AFF"/>
                            <path
                                d="M10.9634 23.252C11.2501 23.5447 11.639 23.7091 12.0445 23.7091C12.45 23.7091 12.8389 23.5447 13.1257 23.252L16.9487 19.3496C17.2354 19.0569 17.3964 18.6599 17.3964 18.246C17.3964 17.8321 17.2354 17.4351 16.9487 17.1424L13.1257 13.2399C12.8373 12.9556 12.451 12.7983 12.05 12.8018C11.6491 12.8054 11.2655 12.9695 10.982 13.259C10.6985 13.5484 10.5376 13.9399 10.5341 14.3492C10.5307 14.7585 10.6848 15.1528 10.9634 15.4472L13.4346 17.9697C13.4702 18.0059 13.4984 18.049 13.5177 18.0964C13.537 18.1438 13.5469 18.1947 13.5469 18.246C13.5469 18.2973 13.537 18.3481 13.5177 18.3956C13.4984 18.443 13.4702 18.486 13.4346 18.5223L10.9634 21.0448C10.6767 21.3375 10.5156 21.7345 10.5156 22.1484C10.5156 22.5623 10.6767 22.9593 10.9634 23.252Z"
                                fill="#4A3AFF"/>
                            <path
                                d="M20.457 23.7098H26.5738C26.9794 23.7098 27.3684 23.5454 27.6551 23.2526C27.9419 22.9599 28.103 22.5629 28.103 22.1489C28.103 21.7349 27.9419 21.3378 27.6551 21.0451C27.3684 20.7523 26.9794 20.5879 26.5738 20.5879H20.457C20.0514 20.5879 19.6624 20.7523 19.3756 21.0451C19.0888 21.3378 18.9277 21.7349 18.9277 22.1489C18.9277 22.5629 19.0888 22.9599 19.3756 23.2526C19.6624 23.5454 20.0514 23.7098 20.457 23.7098Z"
                                fill="#4A3AFF"/>
                        </svg>

                    </div>
                    <span>Płatność na miejscu</span>
                </div>
                {!isCycle && <div className={paymentMethod === RENTAL_MODAL_PRZELEWY24 ? 'active' : ''}
                                  onClick={() => dispatch(createAction(RENTAL_MODAL_SET_PAYMENT_METHOD, RENTAL_MODAL_PRZELEWY24))}>
                    <div className='icon'>
                        <svg width="38" height="33" viewBox="0 0 38 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <rect x="1.97656" y="1.76855" width="33.353" height="28.1681" fill="white"/>
                            <path
                                d="M0.576172 27.612C0.576172 28.854 1.05951 30.0451 1.91986 30.9233C2.78021 31.8015 3.9471 32.2949 5.16382 32.2949H32.6897C33.9064 32.2949 35.0733 31.8015 35.9337 30.9233C36.794 30.0451 37.2774 28.854 37.2774 27.612V4.97785C37.2774 3.73586 36.794 2.54474 35.9337 1.66652C35.0733 0.7883 33.9064 0.294922 32.6897 0.294922H5.16382C3.9471 0.294922 2.78021 0.7883 1.91986 1.66652C1.05951 2.54474 0.576172 3.73586 0.576172 4.97785L0.576172 27.612ZM22.7498 4.19736C22.7427 4.4746 22.6612 4.74455 22.5143 4.97785C22.3867 5.2141 22.1994 5.4111 21.9719 5.5483C21.7443 5.68549 21.4849 5.75786 21.2206 5.75786C20.9563 5.75786 20.6969 5.68549 20.4693 5.5483C20.2418 5.4111 20.0544 5.2141 19.9269 4.97785C19.78 4.74455 19.6985 4.4746 19.6914 4.19736C19.6983 3.92008 19.7797 3.65007 19.9269 3.41687C20.0544 3.18062 20.2418 2.98362 20.4693 2.84643C20.6969 2.70923 20.9563 2.63686 21.2206 2.63686C21.4849 2.63686 21.7443 2.70923 21.9719 2.84643C22.1994 2.98362 22.3867 3.18062 22.5143 3.41687C22.6614 3.65007 22.7429 3.92008 22.7498 4.19736ZM28.1021 4.19736C28.0949 4.4746 28.0135 4.74455 27.8666 4.97785C27.739 5.2141 27.5517 5.4111 27.3241 5.5483C27.0966 5.68549 26.8371 5.75786 26.5728 5.75786C26.3086 5.75786 26.0491 5.68549 25.8216 5.5483C25.594 5.4111 25.4067 5.2141 25.2791 4.97785C25.1322 4.74455 25.0508 4.4746 25.0436 4.19736C25.0505 3.92008 25.132 3.65007 25.2791 3.41687C25.4067 3.18062 25.594 2.98362 25.8216 2.84643C26.0491 2.70923 26.3086 2.63686 26.5728 2.63686C26.8371 2.63686 27.0966 2.70923 27.3241 2.84643C27.5517 2.98362 27.739 3.18062 27.8666 3.41687C28.0137 3.65007 28.0951 3.92008 28.1021 4.19736ZM33.4543 4.19736C33.4472 4.4746 33.3657 4.74455 33.2188 4.97785C33.0912 5.2141 32.9039 5.4111 32.6764 5.5483C32.4488 5.68549 32.1894 5.75786 31.9251 5.75786C31.6608 5.75786 31.4014 5.68549 31.1738 5.5483C30.9463 5.4111 30.759 5.2141 30.6314 4.97785C30.4845 4.74455 30.403 4.4746 30.3959 4.19736C30.4028 3.92008 30.4843 3.65007 30.6314 3.41687C30.761 3.18235 30.9487 2.98676 31.1758 2.84976C31.4029 2.71277 31.6613 2.63917 31.9251 2.63638C32.2189 2.63775 32.5061 2.72548 32.7524 2.88908C32.9986 3.05269 33.1935 3.28524 33.3136 3.55892C33.4048 3.759 33.4527 3.97672 33.4543 4.19736ZM3.6346 8.48848C3.6346 8.38498 3.67488 8.28572 3.74658 8.21254C3.81827 8.13935 3.91551 8.09824 4.01691 8.09824H33.8366C33.938 8.09824 34.0353 8.13935 34.1069 8.21254C34.1786 8.28572 34.2189 8.38498 34.2189 8.48848V27.6104C34.2189 28.0244 34.0578 28.4215 33.771 28.7142C33.4842 29.007 33.0953 29.1714 32.6897 29.1714H5.16382C4.75825 29.1714 4.36928 29.007 4.0825 28.7142C3.79572 28.4215 3.6346 28.0244 3.6346 27.6104V8.48848Z"
                                fill="#4A3AFF"/>
                            <path
                                d="M10.9634 23.252C11.2501 23.5447 11.639 23.7091 12.0445 23.7091C12.45 23.7091 12.8389 23.5447 13.1257 23.252L16.9487 19.3496C17.2354 19.0569 17.3964 18.6599 17.3964 18.246C17.3964 17.8321 17.2354 17.4351 16.9487 17.1424L13.1257 13.2399C12.8373 12.9556 12.451 12.7983 12.05 12.8018C11.6491 12.8054 11.2655 12.9695 10.982 13.259C10.6985 13.5484 10.5376 13.9399 10.5341 14.3492C10.5307 14.7585 10.6848 15.1528 10.9634 15.4472L13.4346 17.9697C13.4702 18.0059 13.4984 18.049 13.5177 18.0964C13.537 18.1438 13.5469 18.1947 13.5469 18.246C13.5469 18.2973 13.537 18.3481 13.5177 18.3956C13.4984 18.443 13.4702 18.486 13.4346 18.5223L10.9634 21.0448C10.6767 21.3375 10.5156 21.7345 10.5156 22.1484C10.5156 22.5623 10.6767 22.9593 10.9634 23.252Z"
                                fill="#4A3AFF"/>
                            <path
                                d="M20.457 23.7098H26.5738C26.9794 23.7098 27.3684 23.5454 27.6551 23.2526C27.9419 22.9599 28.103 22.5629 28.103 22.1489C28.103 21.7349 27.9419 21.3378 27.6551 21.0451C27.3684 20.7523 26.9794 20.5879 26.5738 20.5879H20.457C20.0514 20.5879 19.6624 20.7523 19.3756 21.0451C19.0888 21.3378 18.9277 21.7349 18.9277 22.1489C18.9277 22.5629 19.0888 22.9599 19.3756 23.2526C19.6624 23.5454 20.0514 23.7098 20.457 23.7098Z"
                                fill="#4A3AFF"/>
                        </svg>
                    </div>
                    <span>Przelewy 24</span>
                </div>}
            </div>
            {
                isCycle && <p><b>Lista terminów</b></p>
            }
            {
                isCycle && <div className='term-list' style={{}}>
                    {
                        Object.keys(terms).filter(d => terms[d].slot !== null).map(d => {
                            let slot = terms[d].slot
                            return <div className={'term ' + (slot ? '' : 'invalid')}>
                                <span>{d} {timeFrom} - {timeTo}</span>
                                {slot && <span className='price'>{slot.price} zł</span>}
                                {!slot && <span className='invalid-text'>Termin niedostępny</span>}
                            </div>
                        })
                    }
                </div>
            }
            <div>
                {
                    paymentMethod === RENTAL_MODAL_CASH && <div>
                        Płatność na miejscu, rezerwacja zostanie utworzona natychmiastowo.
                    </div>
                }
                {
                    paymentMethod === RENTAL_MODAL_PRZELEWY24 && <Przelewy24/>
                }
            </div>
        </div>
        <div className='dialog-footer'>
            <Button text='Wróć do podsumowania'
                    extraClasses='secondary'
                    onClick={() => dispatch(createAction(RENTAL_MODAL_SET_STEP, RENTAL_MODAL_STEP_SUMMARY))}
            />
            <Button text={paymentMethod === RENTAL_MODAL_CASH ? 'Utwórz rezerwację' : 'Zapłać'}
                    onClick={() => submit()} loading={submitting}/>
        </div>
    </>
}

export default PaymentForm
